import { createAction } from "@reduxjs/toolkit";

export const revertAllReduxAction = createAction("REVERT_ALL");
